<img class="img" src="./assets/img/lock-landspace.png" />
<div class="text">{{ 'main.lock_landscape.text' | translate }}</div>
